// extracted by mini-css-extract-plugin
export var orderSummary = "_qx-0";
export var showMoreLessButton = "_qx-1";